// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WNEt","type":"styles_type__2NUTN","choices":"styles_choices__z9tVb"};